import { useEffect } from 'react';
import { AnimatePresence } from 'motion/react';
import { useUIStore } from '@/stores/ui-store';
import { useAuthStore } from '@/stores/auth-store';
import { useModelsStore } from '@/stores/models-store';
import { useNotificationsStore } from '@/stores/notifications-store';
import { useCapturesStore } from '@/stores/captures-store';
import BottomNav from '@/components/layout/BottomNav';
import Toast from '@/components/layout/Toast';
import Home from '@/pages/Home';
import Library from '@/pages/Library';
import Profile from '@/pages/Profile';
import ModelDetail from '@/pages/ModelDetail';
import ARCamera from '@/pages/ARCamera';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import NotificationsDrawer from '@/pages/NotificationsDrawer';
import CaptureViewer from '@/pages/CaptureViewer';

export default function App() {
  const { currentTab, selectedModel, isARActive, arModel, authView, setAuthView } = useUIStore();
  const { checkAuth, isAuthenticated, isLoading: authLoading } = useAuthStore();
  const { fetchFavorites } = useModelsStore();
  const { isDrawerOpen: isNotificationsOpen } = useNotificationsStore();
  const { isViewerOpen: isCaptureViewerOpen } = useCapturesStore();

  // Check auth on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Fetch favorites when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchFavorites();
    }
  }, [isAuthenticated, fetchFavorites]);

  // Show auth screens if not authenticated and trying to access protected features
  if (authView === 'login') {
    return (
      <>
        <Login onRegister={() => setAuthView('register')} onClose={() => setAuthView(null)} />
        <Toast />
      </>
    );
  }

  if (authView === 'register') {
    return (
      <>
        <Register onLogin={() => setAuthView('login')} onClose={() => setAuthView(null)} />
        <Toast />
      </>
    );
  }

  return (
    <div className="fixed inset-0 bg-background flex flex-col">
      {/* Main Content */}
      <main className="flex-1 relative overflow-hidden">
        <AnimatePresence mode="wait">
          {!isARActive && currentTab === 'home' && <Home key="home" />}
          {!isARActive && currentTab === 'library' && <Library key="library" />}
          {!isARActive && currentTab === 'profile' && <Profile key="profile" />}
        </AnimatePresence>

        {/* Overlays */}
        <AnimatePresence>
          {selectedModel && !isARActive && (
            <ModelDetail key="detail" model={selectedModel} />
          )}
          {isARActive && <ARCamera key="ar" model={arModel} />}
        </AnimatePresence>
      </main>

      {/* Bottom Navigation */}
      <AnimatePresence>
        {!isARActive && !selectedModel && <BottomNav key="nav" />}
      </AnimatePresence>

      {/* Global Overlays */}
      <AnimatePresence>
        {isNotificationsOpen && <NotificationsDrawer key="notifications" />}
      </AnimatePresence>

      <AnimatePresence>
        {isCaptureViewerOpen && <CaptureViewer key="capture-viewer" />}
      </AnimatePresence>

      {/* Toast Notifications */}
      <Toast />
    </div>
  );
}
